module.exports = __webpack_public_path__ + "static/media/KaTeX_Size3-Regular.2c2f0efb.woff2";